// extracted by mini-css-extract-plugin
module.exports = {"controls":"layout-module--controls--3nt9t"};